/**
 * Open Dropdown on "hover" (Bootstrap's default is "click")
 * @requires https://getbootstrap.com
 * @requires https://popper.js.org/
 */

export default (() => {
  // Properly check for touch support
  if (!('ontouchstart' in window) || !navigator.maxTouchPoints) {
    const dropdownTriggerList = document.querySelectorAll(
      '[data-bs-toggle="dropdown"][data-bs-trigger="hover"]'
    )

    /* eslint-disable no-unused-vars, no-undef */
    const dropdownList = [...dropdownTriggerList].map((dropdownTriggerEl) => {
      const bsDropdown = new bootstrap.Dropdown(dropdownTriggerEl)

      // Define a timer variable for better management of delayed operations
      let hideTimeout = null

      dropdownTriggerEl.addEventListener('click', (e) => {
        if (e.currentTarget.getAttribute('href') === '#') {
          e.preventDefault()
        }
      })

      // Find the actual dropdown menu element
      // Look for .dropdown-menu as nextElementSibling might not always be the menu
      const getDropdownMenu = () => {
        // Try direct next sibling first (most common case)
        if (
          dropdownTriggerEl.nextElementSibling &&
          dropdownTriggerEl.nextElementSibling.classList.contains(
            'dropdown-menu'
          )
        ) {
          return dropdownTriggerEl.nextElementSibling
        }

        // Try to find dropdown menu within the same parent container
        const parent = dropdownTriggerEl.closest('.nav-item, .dropdown')
        if (parent) {
          return parent.querySelector('.dropdown-menu')
        }

        return null
      }
      const dropdownMenu = getDropdownMenu()

      // Show dropdown on hover or mouseover
      const showDropdown = () => {
        // Clear any pending hide operations
        if (hideTimeout) {
          clearTimeout(hideTimeout)
          hideTimeout = null
        }

        dropdownTriggerEl.dataset.bsToggle = 'dropdown-hover'
        bsDropdown.show()
        dropdownTriggerEl.blur()
      }

      // Hide dropdown with delay
      const scheduleHideDropdown = () => {
        // Don't create multiple timeouts
        if (hideTimeout) clearTimeout(hideTimeout)

        hideTimeout = setTimeout(() => {
          // Check if mouse is over either element before hiding
          const overTrigger = dropdownTriggerEl.matches(':hover')
          const overMenu = dropdownMenu ? dropdownMenu.matches(':hover') : false
          if (!overTrigger && !overMenu) {
            dropdownTriggerEl.dataset.bsToggle = 'dropdown'
            bsDropdown.hide()
          }
        }, 150)
      }

      // Add event listeners for trigger element
      dropdownTriggerEl.addEventListener('mouseover', showDropdown)
      dropdownTriggerEl.addEventListener('mouseenter', showDropdown)
      dropdownTriggerEl.addEventListener('mouseleave', scheduleHideDropdown)

      // Add event listeners for dropdown menu if it exists
      if (dropdownMenu) {
        dropdownMenu.addEventListener('mouseenter', showDropdown)
        dropdownMenu.addEventListener('mouseleave', scheduleHideDropdown)
      }

      // Handle focus events
      dropdownTriggerEl.addEventListener('focus', () => {
        bsDropdown.show()
      })

      // Handle keyboard events
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          bsDropdown.hide()
        }
      })
    })
  }
  /* eslint-enable no-unused-vars, no-undef */
})()
